import { Pipe, PipeTransform } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { catchError, Observable, of } from 'rxjs';

@Pipe({
  name: 'request'
})
export class RequestPipe implements PipeTransform {

  constructor(
    private http: HttpClient
  ) { }

  transform(url: string): Observable<string> {
    return this.http.get(url, { responseType: 'text' }).pipe(catchError(this.errorHandler));
  }

  errorHandler(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.log('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.error(
        `Backend returned code ${error.status}, ` +
        `body was: ${error.error}`);
    }
    // return an observable with a user-facing error message

    return 'assets/images/no_img_avaliable.jpg'
  }




}
